// 超出文本添加title
export const ellipsisTitleInit = (app)=>{
  if(!app){ return; };
  app.directive('ellipsis', {
    mounted(el, binding, com){
      // console.log(el, binding, com);
      el.style.overflow = 'hidden';
      el.style.textOverflow = 'ellipsis';
      el.style.whiteSpace = 'nowrap';
      if(el.clientWidth < el.scrollWidth) {
        el.title = el.innerHTML;
      }
    },
  })
}

// el-scrollbar横向 添加鼠标滚轮事件 mousescroll
export const scrollbarMouseScroll = (app)=>{
  if(!app){ return; };
  let scrollLeftVal = 0;
  const handler = (event, el, scrollFn)=>{
    event.stopPropagation && event.stopPropagation();
    event.preventDefault && event.preventDefault();
    // 获取滚动方向
    const detail = event.wheelDelta || event.detail;
    // 定义滚动方向，其实也可以在赋值的时候写
    const moveForwardStep = 1;
    const moveBackStep = -1;
    // 定义滚动距离
    let step = 0, scrollNum = 20; 
    const elScroll = el.querySelector('.el-scrollbar__bar.is-horizontal .el-scrollbar__thumb'),
          elScrollWidth = parseFloat(elScroll.style.width);
    // 判断滚动方向,这里的100可以改，代表滚动幅度，也就是说滚动幅度是自定义的
    if (detail < 0) {
      step = moveForwardStep * scrollNum;
      if(scrollLeftVal >= (el.offsetWidth - elScrollWidth) / elScrollWidth * el.offsetWidth){
        step = 0;
      }
    } else {
      step = moveBackStep * scrollNum;
      if(scrollLeftVal == 0){
        step = 0;
      }
    }
    // 对需要滚动的元素进行滚动操作
    if(scrollFn){
      scrollLeftVal+=step;
      scrollFn(scrollLeftVal + step);
    }
  }
  app.directive('mousescroll', {
    mounted(el, binding, com){
      // console.log(el, binding, com);
      el.addEventListener('mousewheel', (event)=>{
        handler(event, el, com.ref.i.exposed.setScrollLeft || undefined);
        event.preventDefault();
      }, false);
      el.addEventListener('DOMMouseScroll', (event)=>{
        handler(event, el, com.ref.i.exposed.setScrollLeft || undefined);
        event.preventDefault();
      }, false);
    },
  })
}

// dom拖动指令
export const vMoveDirectiveInit = (app)=>{
  if(!app){ return; };
  app.directive('move', {
    mounted(el, binding){
      if(!binding['value'])return
      el.style.cursor = 'move';
      const parentNode = el.parentNode;
      const moveNode = parentNode;
      const transition = window.getComputedStyle(parentNode).transition;
      el.onmousedown = function (e) {
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
        let startX = e.clientX - moveNode.offsetLeft,
          startY = e.clientY - moveNode.offsetTop;
        parentNode.style.transition = 'none';
        document.onmousemove = function (ev) {
          let event = ev || window.event;
          let moveX = event.clientX - startX,
            moveY = event.clientY - startY;
          if (moveX < 0) moveX = 0;
          if (moveX + moveNode.offsetWidth > window.innerWidth) moveX = window.innerWidth - moveNode.offsetWidth;
          if (moveY < 0) moveY = 0;
          // 底部边界
          const titleHeight = moveNode.querySelector('.title').offsetHeight;
          if (moveY + titleHeight + moveNode.offsetHeight > window.innerHeight) {
            moveY = window.innerHeight - moveNode.offsetHeight - titleHeight;
          }
          moveNode.style.left = moveX + "px";
          moveNode.style.top = moveY + "px";
        }

        // 鼠标弹起时不再移动
        document.onmouseup = function () {
          parentNode.style.transition = transition;
          document.onmousemove = null;
        };
      };
      let posX = 0, posY = 0;
      let startX = 0, startY = 0;
      el.addEventListener('touchstart', (e) => {
        // e.preventDefault();
        const touch = e.touches[0];
        startX = touch.clientX - posX;
        startY = touch.clientY - posY;
        
        // 添加移动和结束事件
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('touchend', onTouchEnd);
      }, { passive: false });
      function onTouchMove(e) {
        const touch = e.touches[0];
        posX = touch.clientX - startX;
        posY = touch.clientY - startY;
        
        moveNode.style.transform = `translate(${posX}px, ${posY}px)`;
      }
      
      function onTouchEnd() {
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
      }
    },
  });
  app.directive('move-this', {
    mounted(el, binding){
      // console.log(el, binding);
      const moveNode = el;
      moveNode.style.cursor = 'move';
      el.onmousedown = function (e) {
        e.stopPropagation && e.stopPropagation();
        e.preventDefault && e.preventDefault();
        let startX = e.clientX - moveNode.offsetLeft,
          startY = e.clientY - moveNode.offsetTop;
        document.onmousemove = function (ev) {
          let event = ev || window.event;
          let moveX = event.clientX - startX,
            moveY = event.clientY - startY;
          if (moveX < 0) moveX = 0;
          if (moveX + moveNode.offsetWidth > window.innerWidth) moveX = window.innerWidth - moveNode.offsetWidth;
          if (moveY < 0) moveY = 0;
          if (moveY + moveNode.offsetHeight > window.innerHeight) moveY = window.innerHeight - moveNode.offsetHeight;
          moveNode.style.left = moveX + "px";
          moveNode.style.top = moveY + "px";
        }

        // 鼠标弹起时不再移动
        document.onmouseup = function () {
          document.onmousemove = null;
        };
      };
    },
  });
}